// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__SvwqA","label":"Section_label__2_JiX","contentWrap":"Section_contentWrap__1mL1A","footer":"Section_footer__3FlDl","footerInner":"Section_footerInner__21DL8"};